import React from 'react';
import { ModalProps as MuiModalProps, IconButton, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';
import { StyledModal, ModalContent, ModalHeader, ModalBody } from './Modal.style';
export interface ModalProps extends Omit<MuiModalProps, 'children'> {
  /**
   * Whether the modal is open
   */
  open: boolean;
  /**
   * Callback fired when the modal is closed
   */
  onClose: () => void;
  /**
   * The title of the modal
   */
  title?: string;
  /**
   * The content of the modal
   */
  children: React.ReactNode;
  /**
   * The size of the modal
   */
  size?: 'small' | 'medium' | 'large' | 'fullWidth';
  /**
   * Whether to show the close button
   */
  showCloseButton?: boolean;
  /**
   * Whether clicking the backdrop closes the modal
   */
  closeOnBackdropClick?: boolean;
  /**
   * Custom width for the modal
   */
  maxWidth?: string | number;
  /**
   * Whether the modal should be centered
   */
  centered?: boolean;
}
export const Modal: React.FC<ModalProps> = ({
  open,
  onClose,
  title,
  children,
  size = 'medium',
  showCloseButton = true,
  closeOnBackdropClick = true,
  maxWidth,
  centered = true,
  ...props
}) => {
  const handleBackdropClick = (event: React.MouseEvent) => {
    if (closeOnBackdropClick && event.target === event.currentTarget) {
      onClose();
    }
  };
  return (
    <StyledModal
      open={open}
      onClose={onClose}
      onClick={handleBackdropClick}
      centered={centered}
      {...props}
    >
      <ModalContent size={size} maxWidth={maxWidth}>
        {(title || showCloseButton) && (
          <ModalHeader>
            {title && (
              <Typography variant="h2" component="h2">
                {title}
              </Typography>
            )}
            {showCloseButton && (
              <IconButton
                onClick={onClose}
                size="small"
                sx={{ ml: 'auto' }}
              >
                <Close />
              </IconButton>
            )}
          </ModalHeader>
        )}
        <ModalBody>
          {children}
        </ModalBody>
      </ModalContent>
    </StyledModal>
  );
}; 